var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "queryParams",
          attrs: {
            inline: "",
            "label-width": "60px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入名称" },
                model: {
                  value: _vm.queryParams.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "name", $$v)
                  },
                  expression: "queryParams.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "类别" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入类别" },
                model: {
                  value: _vm.queryParams.category,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "category", $$v)
                  },
                  expression: "queryParams.category",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标识" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标识" },
                model: {
                  value: _vm.queryParams.key,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "key", $$v)
                  },
                  expression: "queryParams.key",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { "label-width": "0px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refresh()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-page", {
        ref: "tablePage",
        attrs: {
          url: "flow/process/page",
          columns: _vm.columns,
          "query-params": _vm.queryParams,
          "check-box": false,
        },
        scopedSlots: _vm._u([
          {
            key: "suspendState",
            fn: function (ref) {
              var row = ref.row
              return [
                row.suspendState
                  ? _c("el-tag", { attrs: { type: "warning" } }, [
                      _vm._v("已挂起"),
                    ])
                  : _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("激活"),
                    ]),
              ]
            },
          },
          {
            key: "action",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["process:approve"],
                        expression: "['process:approve']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.setApprovalUser(row)
                      },
                    },
                  },
                  [_vm._v("设置审批")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["process:chart"],
                        expression: "['process:chart']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.seeProcessPic(row)
                      },
                    },
                  },
                  [_vm._v("流程图")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["process:hang:change"],
                        expression: "['process:hang:change']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.update(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.suspendState ? "激活" : "挂起"))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["process:delete"],
                        expression: "['process:delete']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "流程图",
            "v-if": _vm.dialogProcessPicShow,
            visible: _vm.dialogProcessPicShow,
            "append-to-body": "",
            width: "80%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogProcessPicShow = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "center", padding: "20px" },
                  attrs: { span: 24 },
                },
                [
                  _c("el-image", {
                    attrs: { src: _vm.processPicUrl, alt: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogApprovalShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "流程节点详细",
                visible: _vm.dialogApprovalShow,
                "append-to-body": "",
                width: "80%",
                "modal-append-to-body": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogApprovalShow = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "center", padding: "20px" },
                      attrs: { span: 24 },
                    },
                    [
                      _c("el-image", {
                        attrs: { src: _vm.processPicUrl, alt: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "50px" },
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "flowNodeTable",
                          staticStyle: { width: "100%" },
                          attrs: { border: "", data: _vm.flowNodeTableData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "flowName",
                              label: "节点名称",
                              align: "center",
                              width: "180",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "flowType",
                              label: "审批类型",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return _vm._l(
                                      _vm.flowTypeOptionList,
                                      function (item) {
                                        return row.flowType === item.dictValue
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: { type: item.listClass },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(item.dictLabel) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              2565076496
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "ids", label: "数据" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return _vm._l(row.ids, function (item) {
                                      return _c(
                                        "el-tag",
                                        { attrs: { size: "small" } },
                                        [_vm._v(_vm._s(item))]
                                      )
                                    })
                                  },
                                },
                              ],
                              null,
                              false,
                              417623008
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "action", label: "设置" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setUpFlow(row, $index)
                                            },
                                          },
                                        },
                                        [_vm._v("设置")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1698441206
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFlowNode()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogFlowSetShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "设置审批人",
                visible: _vm.dialogFlowSetShow,
                "append-to-body": "",
                "modal-append-to-body": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFlowSetShow = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.flowNodeRow, "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "审批名称" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.flowNodeRow.flowName,
                          callback: function ($$v) {
                            _vm.$set(_vm.flowNodeRow, "flowName", $$v)
                          },
                          expression: "flowNodeRow.flowName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审批类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择审批类型",
                          },
                          model: {
                            value: _vm.flowNodeRow.flowType,
                            callback: function ($$v) {
                              _vm.$set(_vm.flowNodeRow, "flowType", $$v)
                            },
                            expression: "flowNodeRow.flowType",
                          },
                        },
                        [
                          _vm._l(_vm.flowTypeOptionList, function (item) {
                            return [
                              _c("el-option", {
                                attrs: {
                                  value: item.dictValue,
                                  label: item.dictLabel,
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            filterable: "",
                            remote: "",
                            clearable: "",
                            "reserve-keyword": "",
                            placeholder: "请输入关键词",
                            "remote-method": _vm.remoteMethod,
                            loading: _vm.loading,
                          },
                          model: {
                            value: _vm.flowNodeRow.ids,
                            callback: function ($$v) {
                              _vm.$set(_vm.flowNodeRow, "ids", $$v)
                            },
                            expression: "flowNodeRow.ids",
                          },
                        },
                        _vm._l(_vm.optionData, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveData } },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }